var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyliliusLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 455.73626 441.33347",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#fff;}.cls-3{opacity:0.1;mix-blend-mode:multiply;}.cls-4{fill:url(#D\xE9grad\xE9_sans_nom_2);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_2",
    cx: 233.19048,
    cy: 210.55116,
    r: 277.21765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "171.394 1.247 121.963 50.677 121.457 101.479 170.888 52.047 171.394 1.247"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "279.834 1.367 230.403 50.797 229.897 101.599 279.328 52.167 279.834 1.367"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "176.724 162.68 228.121 214.078 279.039 163.16 279.759 162.44 334.279 107.92 282.882 56.522 228.362 111.042 173.36 56.041 121.722 107.679 176.724 162.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "225.48 101.595 225.119 50.557 175.763 1.201 176.003 52.118 225.48 101.595"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "334.12 100.394 333.759 49.356 284.403 0 284.643 50.917 334.12 100.394"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "284.342 440.087 333.773 390.656 334.279 339.854 284.849 389.286 284.342 440.087"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "175.902 439.967 225.333 390.536 225.839 339.734 176.409 389.166 175.902 439.967"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "279.012 278.653 227.615 227.255 176.698 278.173 175.977 278.893 121.457 333.414 172.854 384.812 227.374 330.291 282.376 385.292 334.014 333.654 279.012 278.653"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "230.257 339.738 230.618 390.776 279.974 440.133 279.733 389.215 230.257 339.738"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "121.616 340.939 121.977 391.977 171.333 441.333 171.094 390.416 121.616 340.939"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "454.49 164.192 405.059 114.762 354.258 114.255 403.689 163.687 454.49 164.192"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "354.138 222.695 403.569 272.127 454.37 272.632 404.939 223.202 354.138 222.695"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "344.695 221.16 399.695 166.16 348.057 114.521 293.057 169.522 241.659 220.92 292.575 271.838 293.297 272.558 347.818 327.078 399.215 275.68 344.695 221.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "403.618 168.802 354.142 218.278 405.18 217.918 454.536 168.561 403.618 168.802"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "404.819 277.442 355.342 326.918 406.38 326.558 455.736 277.202 404.819 277.442"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1.246 277.141 50.677 326.572 101.478 327.078 52.047 277.647 1.246 277.141"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "50.797 218.132 101.598 218.638 52.168 169.207 1.366 168.701 50.797 218.132"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "214.077 220.413 163.161 169.496 162.439 168.775 107.919 114.255 56.521 165.653 111.042 220.173 56.041 275.174 107.679 326.812 162.68 271.811 214.077 220.413"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "101.594 223.055 50.557 223.416 1.2 272.772 52.118 272.532 101.594 223.055"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "100.394 114.415 49.356 114.775 0 164.132 50.917 163.892 100.394 114.415"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "171.394 1.247 121.963 50.677 121.457 101.479 170.888 52.047 171.394 1.247"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "279.834 1.367 230.403 50.797 229.897 101.599 279.328 52.167 279.834 1.367"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "176.724 162.68 228.121 214.078 279.039 163.16 279.759 162.44 334.279 107.92 282.882 56.522 228.362 111.042 173.36 56.041 121.722 107.679 176.724 162.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "225.48 101.595 225.119 50.557 175.763 1.201 176.003 52.118 225.48 101.595"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "334.12 100.394 333.759 49.356 284.403 0 284.643 50.917 334.12 100.394"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "284.342 440.087 333.773 390.656 334.279 339.854 284.849 389.286 284.342 440.087"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "175.902 439.967 225.333 390.536 225.839 339.734 176.409 389.166 175.902 439.967"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "279.012 278.653 227.615 227.255 176.698 278.173 175.977 278.893 121.457 333.414 172.854 384.812 227.374 330.291 282.376 385.292 334.014 333.654 279.012 278.653"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "230.257 339.738 230.618 390.776 279.974 440.133 279.733 389.215 230.257 339.738"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "121.616 340.939 121.977 391.977 171.333 441.333 171.094 390.416 121.616 340.939"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "454.49 164.192 405.059 114.762 354.258 114.255 403.689 163.687 454.49 164.192"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "354.138 222.695 403.569 272.127 454.37 272.632 404.939 223.202 354.138 222.695"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "344.695 221.16 399.695 166.16 348.057 114.521 293.057 169.522 241.659 220.92 292.575 271.838 293.297 272.558 347.818 327.078 399.215 275.68 344.695 221.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "403.618 168.802 354.142 218.278 405.18 217.918 454.536 168.561 403.618 168.802"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "404.819 277.442 355.342 326.918 406.38 326.558 455.736 277.202 404.819 277.442"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1.246 277.141 50.677 326.572 101.478 327.078 52.047 277.647 1.246 277.141"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "50.797 218.132 101.598 218.638 52.168 169.207 1.366 168.701 50.797 218.132"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "214.077 220.413 163.161 169.496 162.439 168.775 107.919 114.255 56.521 165.653 111.042 220.173 56.041 275.174 107.679 326.812 162.68 271.811 214.077 220.413"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "101.594 223.055 50.557 223.416 1.2 272.772 52.118 272.532 101.594 223.055"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "100.394 114.415 49.356 114.775 0 164.132 50.917 163.892 100.394 114.415"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyliliusLogo);
export default __webpack_public_path__ + "static/media/mylilius_logo.ca7baee18ae0fd0ec774585ca8a10e95.svg";
export { ForwardRef as ReactComponent };